module.exports = __webpack_public_path__ + "static/img/item1.1787098.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dist/item1.jpg
// module id = fCq+
// module chunks = 1